import { getModelName, isDeviceClickable } from "../../utils";
import { Link } from "../../components";
import { ReactComponent as PlayIcon } from "../../assets/icons/device-media-control.svg";
import { ReactComponent as SettingsIcon } from "../../assets/icons/device-setting-icon.svg";
import { ReactComponent as VoiceControlIcon } from "../../assets/icons/micro-icon.svg";
import { deviceImages } from "../../constants/images";
import { oemValues } from "../../constants/oem";
import { selectDevice } from "../../redux/voiceControl-slice";
import styles from "./DeviceCardListView.module.scss";
import { useDispatch } from "react-redux";

export function DeviceCardListView({ device }) {
  const dispatch = useDispatch();
  function handleDeviceCardClick() {
    window.open(`https://${device.cloudId}.${oemValues.cloudDomain}`, "_blank");
  }

  return (
    <div className={styles.deviceCard}>
      <div className={styles.deviceCardWrapper}>
        <div className={styles.deviceImage}>
          <img src={deviceImages[device.model]} alt="device-list-view" />
        </div>
        <div className={styles.deviceInfo}>
          <div className={styles.deviceModel}>{getModelName(device.model)}</div>
          <div className={styles.deviceName}>
            {getModelName(device.model, device.friendly_name)}
          </div>
        </div>
        <div className={styles.deviceBtnGroup}>
          <Link
            to={`/device-settings/${device.cloudId}`}
            className={styles.deviceIconLink}
          >
            <SettingsIcon className={styles.deviceSettingsIcon} />
          </Link>
          {!isDeviceClickable(device.model) && (
            <PlayIcon
              className={styles.devicePlayIcon}
              onClick={handleDeviceCardClick}
            />
          )}
          {device.voice_control && (
            <Link
              /* This route only exists on mobile, but will be automatically
               * redirected to /voice on desktop (see routes in App.js)
               */
              to={`/voice/${device.cloudId}/controls`}
              onClick={() => {
                dispatch(selectDevice(device));
              }}
              className={styles.deviceIconLink}
            >
              <VoiceControlIcon className={styles.deviceMicroIcon} />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
